import { tabsAnatomy } from '@chakra-ui/anatomy'
import { createMultiStyleConfigHelpers, defineStyle } from '@chakra-ui/react'

const { definePartsStyle, defineMultiStyleConfig } = createMultiStyleConfigHelpers(
    tabsAnatomy.keys,
)

const baseStyle = definePartsStyle({
    tablist: defineStyle({}),
})

const variants = {
    primary: definePartsStyle(({ theme }) => {
        const colors = theme.colors

        return {
            tab: {
                textTransform: 'uppercase',
                color: colors.captions.light,
                fontWeight: 500,
                fontSize: '0.625rem',
                lineHeight: '0.9375rem',
                px: 0,
                // Tabs carry no padding of their own, so after the resize the tap area is only
                // the text itself. There is no box to grow with a hit-area overlay, so the height
                // comes from responsive padding instead. See MOBILE_TOUCH_TARGET in theme/scales.ts.
                py: { base: '14px', md: 0 },
                borderBottomWidth: '2px',
                borderBottomColor: 'transparent',

                _selected: {
                    borderColor: colors.green.default,
                    color: colors.green.default,
                },
                _hover: {
                    color: colors.green.default,
                },
                ':not(:last-child)': {
                    mr: '15px',
                },
            },
            tabpanel: {
                p: 0,
            },
        }
    }),
}

export const Tabs = defineMultiStyleConfig({
    baseStyle,
    variants,
    defaultProps: {
        variant: 'primary',
    },
})
